import React from "react";
import styles from "./historicalTrend.module.scss";
import { 
  Chart as ChartJS, LineElement, PointElement, LinearScale, Title, Tooltip, Legend, CategoryScale 
} from "chart.js";
import { Line } from "react-chartjs-2";

// Register the necessary Chart.js components
ChartJS.register(LineElement, PointElement, LinearScale, Title, Tooltip, Legend, CategoryScale);

interface DeviceDataType {
  deviceId: string;
  temperature: number;
  humidity: number;
  resistance: number;
  updatedAt: string;
}

interface HistoricalTrendProps {
  deviceData?: DeviceDataType[] | null;
}

const HistoricalTrend: React.FC<HistoricalTrendProps> = ({ deviceData }) => {

  const labels = deviceData
    ? deviceData.map((data) => {
        const date = new Date(data.updatedAt);
        return date.toLocaleString("de-DE", { day: "2-digit", month: "2-digit" }); 
      })
    : [];

  const temperatureData = {
    labels,
    datasets: [
      {
        label: "Temperatur (°C)",
        data: deviceData ? deviceData.map((t) => t.temperature) : [], 
        borderColor: "#F8AC1D",
        backgroundColor: "white",
        pointBorderColor: "#F8AC1D",
        pointBackgroundColor: "white",
        borderWidth: 1.4,
        tension: 0.5,
        pointRadius: 0.5,         
        pointHoverRadius: 4,   
      },
    ],
  };

  const humidityData = {
    labels,
    datasets: [
      {
        label: "Luftfeuchtigkeit (%)",
        data: deviceData ? deviceData.map((h) => h.humidity) : [], 
        borderColor: "#5733AD",
        backgroundColor: "white",
        pointBorderColor: "#5733AD",
        pointBackgroundColor: "white",
        borderWidth: 1.4,
        tension: 0.4,
        pointRadius: 0.5,         
        pointHoverRadius: 4,   
      },
    ],
  };

  const resistanceData = {
    labels,
    datasets: [
      {
        label: "Oberflächenfeuchtigkeit (%)",
        data: deviceData ? deviceData.map((r) => r.resistance) : [], 
        borderColor: "#127E19",
        backgroundColor: "white",
        pointBorderColor: "#127E19",
        pointBackgroundColor: "white",
        borderWidth: 1.4,
        tension: 0.4,
        pointRadius: 0.5,         
        pointHoverRadius: 4,   
      },
    ],
  };

  return (
    <div className={styles.wrapper}>
      <h3 className={styles.wrapTitle}>Monatliche Temperaturentwicklung</h3>
      <Line data={temperatureData} />
      <h3 className={styles.wrapTitle}>Monatliche Luftfeuchtigkeitstrends</h3>
      <Line data={humidityData} />
      <h3 className={styles.wrapTitle}>Oberflächenfeuchtigkeitstrends nach Monat</h3>
      <Line data={resistanceData} />
    </div>
  );
};

export default HistoricalTrend;
